import api from "./ApiClient";

const BASE_PATH_ORDERS = '/foodz/api/v1/vendas';
class OrderService {
  static async getAllOrders(currentPage, pageSize, range) {
    const clientCode = sessionStorage.getItem('clientCode');
    const params = { clientCode, page: currentPage, size: pageSize, start: range.start, end: range.end };
    const response = await api.get(
      `${BASE_PATH_ORDERS}/consultarVendas`,
      { params }
    );
    return response.data;
  }

  static async getAllOrdersFromClient(searchInput) {
    const clientCode = sessionStorage.getItem('clientCode');
    const params = { clientCode, searchInput };
    const response = await api.get(
      `${BASE_PATH_ORDERS}/consultarPedidos`,
      { params }
    );
    return response.data;
  }

  static async getAllCreditRechargesFromClient(searchInput) {
    const clientCode = sessionStorage.getItem('clientCode');
    const params = { clientCode, searchInput };
    const response = await api.get(
      `${BASE_PATH_ORDERS}/consultarRecargasCliente`,
      { params }
    );
    return response.data;
  }

  static async getAllExpensesForClient(searchInput) {
    const clientCode = sessionStorage.getItem('clientCode');
    const params = { clientCode, searchInput };
    const response = await api.get(
      `${BASE_PATH_ORDERS}/consultarDespesasCliente`,
      { params }
    );
    return response.data;
  }

  static async getClientTodayTotalSpent(searchInput) {
    const clientCode = sessionStorage.getItem('clientCode');
    const params = { clientCode, searchInput };
    const response = await api.get(
      `${BASE_PATH_ORDERS}/consultarGastoDiarioTotal`,
      { params }
    );
    return response.data;
  }

  static async registerOrder(order) {
    try {
      const response = await api.post(`${BASE_PATH_ORDERS}/registrarVenda`, order);

      window.__lastRegisterOrderResponse = {
        status: response.status,
        data: response.data,
        headers: response.headers,
      };
      return { status: response.status, data: response.data, headers: response.headers };
    } catch (err) {
      console.error('OrderService.registerOrder -> erro:', err);
      if (err && err.response) {
        const { status, data } = err.response;
        const e = new Error('registerOrder failed');
        e.status = status;
        e.data = data;
        throw e;
      }
      throw err;
    }
  }

  static async updateOrderStatus(order) {
    try {
      const params = { searchInput: order.order_id };
      const response = await api.put(
        `${BASE_PATH_ORDERS}/atualizarStatusVenda`,
        order,
        { params }
      );

      window.__lastUpdateOrderResponse = {
        status: response.status,
        data: response.data,
        headers: response.headers,
      };
      return { status: response.status, data: response.data, headers: response.headers };
    } catch (err) {
      console.error('OrderService.updateOrderStatus -> erro:', err);
      if (err && err.response) {
        const { status, data } = err.response;
        const e = new Error('updateOrderStatus failed');
        e.status = status;
        e.data = data;
        throw e;
      }
      throw err;
    }
  }

  static async deleteCanceledOrder(orderId) {
    const clientCode = sessionStorage.getItem('clientCode');
    const params = { clientCode, searchInput: orderId };
    const response = await api.delete(
      `${BASE_PATH_ORDERS}/cancelarVenda`,
      { params }
    );
    return response.data;
  }

  static async getAllOrdersInPaymentProcess(today, currentPage, pageSize) {
    const clientCode = sessionStorage.getItem('clientCode');
    const params = { clientCode, searchInput: today, page: currentPage, size: pageSize };
    const response = await api.get(
      `${BASE_PATH_ORDERS}/pedidosAReceber`,
      { params }
    );
    return response.data;
  }
}

export default OrderService;